import { useNavigate } from "react-router-dom";
import CardTitle from "../../components/styled/CardTitle";
import CardList from "../../components/styled/CardList";
import { arrayMap } from "../../utils/array.utils";
import { viewCustomerFormatterFunc } from "../../utils/moneyReceipt.utils";

export default function CustomerInformation({ data }) {
  const navigate = useNavigate();

  const profile = data?.customer?.profile;
  const address = data?.customer?.address;
  const customerId = data?.old?.customer?.customer_id;

  const handleView = (customer_id) => {
    if (customer_id) {
      navigate(`/customer/${customer_id}/view`);
    }
  };

  const formattedData = viewCustomerFormatterFunc(
    { ...profile, address, customer_id: customerId },
    { handleCustomerView: handleView }
  );

  return (
    <div className="card border-0">
      <div className="card-body ">
        <CardTitle>Customer Information</CardTitle>
        <CardList className="list-unstyled m-0">
          {arrayMap(formattedData, (item, index) => (
            <li key={index}>
              <b>{item.label}</b>: {item.value}
            </li>
          ))}
        </CardList>
      </div>
    </div>
  );
}
